export class TealiumConfiguration{
    isEnabled: string;
    account: string;
    profile: string;
    environment: string;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/instrumentation/tealium/tealium-config.ts